<template>
  <div class="login">
    <div class="login__inner">
      <Sidebar />
      <div class="login__rs">
        <div class="login__logo-intro--above">
          <img src="@/assets/cia_logo_white.svg" alt="CIA" class="mb-5">
        </div>
        <LoginForm />
      </div>
    </div>
  </div>
</template>

<script>
import LoginForm from './../components/Login/LoginForm.vue';
import Sidebar from './../components/Login/Sidebar.vue';

export default {
  name: 'login',
  components: {
    LoginForm,
    Sidebar,
  },
};
</script>
